import type { DurationScaleInput, MotionPrefs } from './types'

/**
 * Convert a simulation-space duration to Phaser tween milliseconds.
 * At 3x, a 500ms sim action becomes ~167ms real so combat does not feel sluggish.
 * When paused, callers should freeze tweens rather than rely on this alone.
 */
export function scaleSimDurationMs(input: DurationScaleInput): number {
  const speed = Math.max(1, input.prefs.simulationSpeed || 1)
  let ms = input.simMs / speed
  if (input.prefs.reducedMotion) {
    ms = input.essential ? Math.min(ms, 120) : Math.min(ms, 80)
  }
  return Math.max(16, ms)
}

/** Phaser tween timeScale: freeze world tweens while paused; otherwise 1 (speed baked into duration). */
export function worldTweenTimeScale(prefs: MotionPrefs): number {
  return prefs.paused ? 0 : 1
}

/** Advance simulation presentation clock (seconds). */
export function advanceSimClock(
  current: number,
  realDeltaSec: number,
  prefs: MotionPrefs
): number {
  if (prefs.paused) return current
  const speed = Math.max(1, prefs.simulationSpeed || 1)
  return current + realDeltaSec * speed
}

export function prefersReducedMotion(matchMedia?: (query: string) => MediaQueryList): boolean {
  try {
    const mm = matchMedia ?? (typeof window !== 'undefined' ? window.matchMedia.bind(window) : undefined)
    if (!mm) return false
    return mm('(prefers-reduced-motion: reduce)').matches === true
  } catch {
    return false
  }
}
